import React from 'react';
import { useTranslation } from "@/lib/i18n";
import {START_ZOOM_PERCENTAGE} from "@/constants/editor";

export default function CanvasTopPanel({
  zoomLevel,
  onResetZoom,
  theme = 'dark',
}) {
  const { t } = useTranslation('editor');
  const isDark = theme === 'dark';

  return (
    <div className={`absolute top-8 right-3 z-30 flex items-center gap-1.5 backdrop-blur p-1 rounded-lg text-xs transition-colors duration-300 ${
      isDark 
        ? 'bg-zinc-950/80 border-zinc-800 text-zinc-300' 
        : 'bg-white/80 border-slate-200 text-slate-600 shadow-sm'
    } border`}>
      <span className={`text-[11px] ${isDark ? 'text-zinc-400' : 'text-slate-500'}`}>
        {t('canvas.hold')}{' '}
        <kbd className={`px-1 py-0.5 rounded border ${
          isDark ? 'bg-zinc-800 border-zinc-700 text-zinc-200' : 'bg-slate-100 border-slate-200 text-slate-700'
        }`}>{t('canvas.rmb')}</kbd> {t('canvas.to_move')}
      </span>
      <div className={`h-3 w-[1px] ${isDark ? 'bg-zinc-800' : 'bg-slate-200'}`} />
      <span>
        {t('canvas.zoom')}: <strong className={isDark ? 'text-white' : 'text-slate-900'}>{zoomLevel}%</strong>
      </span>
      <button
        onClick={onResetZoom}
        className={`px-1.5 py-0.5 rounded transition text-[10px] ${
          isDark 
            ? 'bg-zinc-800 hover:bg-zinc-700 text-zinc-200 hover:text-white' 
            : 'bg-slate-100 hover:bg-slate-200 text-slate-700 hover:text-slate-900'
        }`}
        title={t('canvas.reset_zoom_title')}
      >
        {START_ZOOM_PERCENTAGE}%
      </button>
    </div>
  );
}